<template>
  <v-container>
    <v-btn class="ma-2" color="secondary" to="/admin/keuangan/list">
      <v-icon left> mdi-arrow-left </v-icon>
      Kembali
    </v-btn>
    <div>
      <v-row no-gutters>
        <v-col cols="4">
          <v-card class="pa-4 ma-2 card-text" outlined tile>
            <div class="title mb-4">Total Pemasukan</div>
            <div class="display-1">
              Rp {{
                dataKeuangan.dist_income.sumIncome.toLocaleString("id-ID")
              }}
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="pa-4 ma-2 card-text" outlined tile>
            <div class="title mb-4">Total Pengeluaran</div>
            <div class="display-1">
              Rp {{
                dataKeuangan.dist_expenses.sumExpenses.toLocaleString("id-ID")
              }}
            </div>
          </v-card>
        </v-col>
        <v-col cols="4">
          <v-card class="pa-4 ma-2 card-text" outlined tile>
            <div class="title mb-4">Total Saldo</div>
            <div class="display-1">
              Rp {{
                dataKeuangan.dist_balances.sumBalances.toLocaleString("id-ID")
              }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="chart-container">
        <v-col cols="12">
          <v-card class="pa-4 ma-2" outlined tile>
            <div class="title mb-4">Distribusi Pemasukan</div>
            <div class="chart-body">
              <BarChart :chartData="chartIncome" :options="optionChart" />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="chart-container">
        <v-col cols="12">
          <v-card class="pa-4 ma-2" outlined tile>
            <div class="title mb-4">Distribusi Pengeluaran</div>
            <div class="chart-body">
              <BarChart :chartData="chartExpense" :options="optionChart" />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="chart-container">
        <v-col cols="12">
          <v-card class="pa-4 ma-2" outlined tile>
            <div class="title mb-4">Distribusi Saldo</div>
            <div class="chart-body">
              <BarChart :chartData="chartBalances" :options="optionChart" />
            </div>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<style>
.card-text {
  height: 150px;
}
.chart-container {
  margin-top: 0;
}
/* .chart-body {
      height: 400px;
  } */
</style>

<script>
import BarChart from "@/components/BarChart";

export default {
  components: {
    BarChart,
  },
  data() {
    return {
      dataKeuangan: {
        dist_income: {
          data: [],
          labels: [],
          sumIncome: 0,
        },
        dist_expenses: {
          data: [],
          labels: [],
          sumExpenses: 0,
        },
        dist_balances: {
          data: [],
          labels: [],
          sumBalances: 0,
        },
      },
      optionChart: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        showLines: false,
        scales: {
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
    };
  },

  async created() {
    await this.axios("/keuangan/list")
      .then((res) => {
        console.log(res.data.data, 'res fetch keuangan')
        let itemsIn = [];
        let itemsOut = [];

        res.data.data.map((el) => {
          if (el.transaction == "in") {
            itemsIn.push(el);
          } else {
            itemsOut.push(el);
          }
        });
        //SORTING ITEMS BY DATE
        itemsIn.sort(this.sortingItems);
        itemsOut.sort(this.sortingItems);

        // console.log(itemsIn, 'income')
        // console.log(itemsOut, 'expenses')

        itemsIn.map((el) => {
          this.dataKeuangan.dist_income.data.push(el.value);
          this.dataKeuangan.dist_income.labels.push(
            this.$moment(el.date).format("MM/YY")
          )
          this.dataKeuangan.dist_income.sumIncome += Number(el.value);
        });

        itemsOut.map((el) => {
          this.dataKeuangan.dist_expenses.data.push(el.value);
          this.dataKeuangan.dist_expenses.labels.push(
            this.$moment(el.date).format("MM/YY")
          )
          this.dataKeuangan.dist_expenses.sumExpenses += Number(el.value);
        });
      })
      .catch((err) => {
        console.log(err);
      });

    let arrBalances = this.dataKeuangan.dist_balances.data;
    let arrExpense = this.dataKeuangan.dist_expenses.data;
    let arrIncome = this.dataKeuangan.dist_income.data;
    let arrIncomeLength = this.dataKeuangan.dist_income.data.length;
    let balances = 0;
    this.dataKeuangan.dist_balances.labels = this.dataKeuangan.dist_expenses.labels;

    for (let i = 0; i < arrIncomeLength; i++) {
      let monthlyBalances = 0;

      monthlyBalances = arrIncome[i] - arrExpense[i];
      balances += monthlyBalances;
      arrBalances.push(balances);
    }

    this.dataKeuangan.dist_balances.sumBalances = balances;
  },

  computed: {
    chartIncome: function () {
      let data = this.dataKeuangan.dist_income.data.slice().reverse().slice(0, 12).reverse();
      let labels = this.dataKeuangan.dist_income.labels.slice().reverse().slice(0, 12).reverse();
      // console.log(this.dataKeuangan);
      return {
        datasets: [
          {
            label: "Distribusi Pemasukan",
            backgroundColor: "#009688",
            borderColor: "#009688",
            fill: false,
            lineTension: 0,
            radius: 5,
            data: data,
          },
        ],
        labels: labels,
      };
    },

    chartExpense: function () {
      let data = this.dataKeuangan.dist_expenses.data.slice().reverse().slice(0, 12).reverse();
      let labels = this.dataKeuangan.dist_expenses.labels.slice().reverse().slice(0, 12).reverse();
      // console.log(this.dataKeuangan);
      return {
        datasets: [
          {
            label: "Distribusi Pengeluaran",
            backgroundColor: "#009688",
            borderColor: "#009688",
            fill: false,
            lineTension: 0,
            radius: 5,
            data: data,
          },
        ],
        labels: labels,
      };
    },

    chartBalances: function () {
      let data = this.dataKeuangan.dist_balances.data.slice().reverse().slice(0, 12).reverse();
      let labels = this.dataKeuangan.dist_balances.labels.slice().reverse().slice(0, 12).reverse();
      // console.log(this.dataKeuangan);
      return {
        datasets: [
          {
            label: "Distribusi Saldo",
            backgroundColor: "#009688",
            borderColor: "#009688",
            fill: false,
            lineTension: 0,
            data: data,
          },
        ],
        labels: labels,
      };
    },
  },
  methods: {
    sortingItems(a, b) {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    },
  },
};
</script>